import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';

import { Button, Col, Form, Row } from 'antd';
import { createIsRequestedSelector, createSonarSelector } from '@lib/selectors';
import { FirstName, LastName } from '@ui/form-items';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';

const patchUserStateSelector = createSonarSelector((state) => state.core.users.current.patch);
const isUserUpdatingSelector = createIsRequestedSelector(patchUserStateSelector);
const buttonText = `${COPY_SPECIFIC.UPDATE} ${COPY_SPECIFIC.NAME}`;

export const AccountInformation: React.FC = () => {
	const { firstName, lastName, id } = useCurrentUser();
	const isUserUpdating = useSonarSelector(isUserUpdatingSelector);

	const updateUser = useAction(coreActions.requestPatchCoreUsersCurrent);

	const handleFinish = useCallback(
		(userUpdateOptions: { firstName: string; lastName: string }) => {
			if (!id) {
				return;
			}

			updateUser({
				...userUpdateOptions,
				userId: id
			});
		},
		[ id, updateUser ]
	);

	return (
		<div id='account-information'>
			<Form
				initialValues={ {
					firstName,
					lastName
				} }
				layout='vertical'
				name='account-information'
				onFinish={ handleFinish }
				requiredMark={ false }>
				<Row gutter={ 16 }>
					<Col span={ 12 }>
						<FirstName
							disabled={ false }
							id='user-first-name'
							label={ COPY_SPECIFIC.FIRST_NAME } />
					</Col>
					<Col span={ 12 }>
						<LastName
							disabled={ false }
							id='user-last-name'
							label={ COPY_SPECIFIC.LAST_NAME } />
					</Col>
				</Row>
				<Button
					disabled={ isUserUpdating }
					htmlType='submit'
					id='update-user-name-submit-button'
					type='primary'>
					{ buttonText }
				</Button>
			</Form>
		</div>
	);
};
